export enum PreferredPronouns {
  OTHER = 1,
  HE,
  SHE,
  THEY
}
